import React, { useCallback } from 'react';
import i18n from '../../Shared/Translation/i18n';
import InputCont from '../../Shared/Form/InputCont';
import useDetail from '../../Shared/useDetail';
import { ApiUrl } from '../../project/Defines.js';
import { EVENT_NAME } from '../../project/utilities';

export default function Services() {
    const reloadEvent = EVENT_NAME.SALES_NETWORK_SERVICE_LIST_UPDATE;

    const { dataItem, setDataItem, updateData, validation } = useDetail({
        data: {},
        onLoadData: (response, _setDataItem) => {
            const data = [];

            for (const element of response.data) {
                if (!data.filter((item) => item.serviceId === element.serviceNumber).length) {
                    data.push({
                        serviceId: element.serviceNumber,
                        serviceLabel: element.serviceLabel,
                        active: element.active,
                        isServiceSelected: !!response.data.find((j) => j.serviceNumber === element.serviceNumber && j.isServiceSelected),
                        subServices: response.data.filter((j) => j.serviceNumber === element.serviceNumber && j.serviceId !== 0)
                    });
                }
            }
            _setDataItem(data);
            
            return true;
        },
        updateUrl: ApiUrl.SalesNetworkServicesUpdate,
        dataLoadUrl: ApiUrl.SalesNetworkServicesLoad,
        reloadEvent
    });

    const updateSuccessCallback = useCallback((response) => {
        return true;
    }, []);

    const dataChange = (e) => {
        const newData = [...dataItem];

        for (const element of newData) {
            if (element.serviceLabel === e.target.name) {
                element.isServiceSelected = e.target.checked;

                if (!e.target.checked) {
                    for (let service of element.subServices)
                        service.isServiceSelected = false;
                } else {
                    for (let service of element.subServices) {
                        if(service.active) service.isServiceSelected = true;
                    }
                }
                break;
            }

        }

        updateData(updateSuccessCallback, null, { overrideData: { serviceId: +e.target.value, isChecked: e.target.checked, changeAll: true } });

        setDataItem(newData);
    }

    const subDataChange = (e, parentID) => {// NOSONAR
        const newData = [...dataItem];

        for (const element of newData) {
            if (element.serviceId === parentID) {
                if (!element.isServiceSelected && e.target.checked) {
                    element.isServiceSelected = true;
                    updateData(updateSuccessCallback, null, { overrideData: { serviceId: element.serviceId, isChecked: e.target.checked, changeAll: false } });
                }

                if (!e.target.checked && element.subServices.filter(subItem => subItem.isServiceSelected).length === 1) {
                    element.isServiceSelected = false;
                    updateData(updateSuccessCallback, null, { overrideData: { serviceId: element.serviceId, isChecked: e.target.checked, changeAll: false } });
                    for (let service of element.subServices) {
                        if (service.subServiceLabel === e.target.name) {
                            service.isServiceSelected = e.target.checked;
                        }
                    }

                    setDataItem(newData);
                    return;
                }

                for (let service of element.subServices) {
                    if (service.subServiceLabel === e.target.name) {
                        service.isServiceSelected = e.target.checked;
                    }
                }
                break;
            }
        }

        updateData(updateSuccessCallback, null, { overrideData: { serviceId: +e.target.value,  isSubService: true, isChecked: e.target.checked } });

        setDataItem(newData);
    };

    return <div className="section_group">
        <div className="sections extra">
            <div className="form_fields"><div className="section_title"><text>{i18n("text.services")}</text></div><div className="form_separator"></div></div>
            {
                dataItem && dataItem.map(item => (<div className="form_fields" key={item.serviceLabel}>
                    <cont>
                        <div style={{ 'minWidth': '300px' }}>
                            <InputCont
                                label={item.serviceLabel}
                                inputProps={{
                                    validation,
                                    name: item.serviceLabel,
                                    type: 'checkbox',
                                    value: item.serviceId,
                                    onChange: dataChange,
                                    checked: item.isServiceSelected,
                                    disabled: !item.active
                                }} />
                        </div>
                        {item.subServices && item.subServices.length !== 0 && item.subServices.map(subItem =>
                        (<InputCont
                            key={subItem.subServiceLabel}
                            label={subItem.subServiceLabel}
                            inputProps={{
                                validation,
                                name: subItem.subServiceLabel,
                                type: 'checkbox',
                                value: subItem.serviceId,
                                onChange: (e) => { subDataChange(e, item.serviceId) },
                                checked: subItem.isServiceSelected,
                                disabled: !subItem.active
                            }} />
                        ))}
                    </cont>
                </div>))
            }
        </div>
    </div>
}